import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle() {
    this.element.classList.toggle('is-open')
  }

  close(event) {
    if (!this.element.contains(event.target)) {
      this.element.classList.remove('is-open')
    }
  }

  connect() {
    this._close = this.close.bind(this)
    document.addEventListener('click', this._close)
  }

  disconnect() {
    document.removeEventListener('click', this._close)
  }
}
